<template>
  <div class="baniere">
    <img
      src="../../../assets/images/jpg/carriere.jpg"
      alt=""
      data-aos="fade-up"
      data-aos-duration="2000"
    >
  </div>
</template>

<script>

export default {
  name: 'Index',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    img{
      height: 262px;
      object-fit: cover;
      object-position: left;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
  }
</style>
